module.exports = __webpack_public_path__ + "static/media/react-brands.b457ab25.svg";